:host {
  display: block;
  margin-bottom: 20px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: #003071;
  font-weight: 600;
  font-family: "Arizona",sans-serif;
  line-height: 1.1;
  margin: 0;
  padding: 0;
}

h1 {
  color: #000;
  font-size: 40px; /* 2.5rem */
  font-weight: 900;
  padding-bottom: 12px;
}

h2 {
  font-size: 36px; /* 2.25rem */
  margin-top: 20px;
}

h3 {
  color: #000;
  font-size: 30px; /* 1.875rem */
}

h4 {
  font-size: 25px; /* 1.563rem */
}

h5 {
  font-size: 23px; /* 1.438rem */
}

h6 {
  font-size: 20px; /* 1.25rem */
}

body,
p {
  color: #333;
  font-family: "Arizona",sans-serif;
  font-size: 20px; /* 1.25rem */
  line-height: 1.5;
  margin: 0 0 15px;
}

ul,
ol {
  margin: 0 0 10px;
  padding: 0 0 0 40px;
}

ul li+li {
  margin-top: 0;
}

li {
  padding: 0;
}

ol li {
  margin: 4px 0;
}

a,
a:link,
a:visited {
  color: #006da3;
  cursor: pointer;
  font-weight: 700;
  text-decoration: none;
}

a:hover,
a:focus {
  color: #003071;
  text-decoration: underline;
}

blockquote {
  background-color: #f5f5f5;
  border-left: 4px solid #003071;
  color: #555;
  display: table;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 0 20px;
  padding: 12px 30px;
  width: 100%;
}

.typography__info {
  border-bottom: 1px solid #000000;
  font-size: 0.75rem; /* 12px */
  margin: 8px 0 16px;
  padding-bottom: 16px;
}
